export type NoteEntityType = 'task' | 'asset' | 'user';

// depending on the type we prepopulate a different uid key in the form default values
export const noteEntityConfig: Record<NoteEntityType, Record<'entityUidKey' | 'griegPath' | 'appRoute', string>> = {
  task: { entityUidKey: 'taskUid', griegPath: 'task-notes', appRoute: 'tasks' },
  asset: { entityUidKey: 'assetUid', griegPath: 'asset-notes', appRoute: 'assets' },
  user: { entityUidKey: 'userUid', griegPath: 'user-notes', appRoute: 'people/users' },
};
